import { useMutation, useQuery } from "@tanstack/react-query";
import newApi from "src/newApi";

import { queryClient } from "src/queryClient";
import options from "./defaultOptions";

export function useCooperations() {
	return useQuery({
		queryKey: ["cooperations"],
		queryFn: () => newApi.getCooperations(),
		...options,
		staleTime: 60 * 1000,
		gcTime: 60 * 1000,
	});
}

export function useCloseCooperations() {
	return useMutation({
		mutationFn: ({ id }) => {
			return newApi.closeCooperation(id);
		},
		onSuccess: () => {
			queryClient.removeQueries({ queryKey: ["cooperations"] });
		},
	});
}
